import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-586d1470"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "pickup"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "choice" }
const _hoisted_4 = { class: "information" }
const _hoisted_5 = {
  key: 1,
  class: "not-available"
}
const _hoisted_6 = { class: "top-imgs" }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Sorry, there is no pickup station under your choice.", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pickup-p" }, "You may choose to:", -1))
const _hoisted_10 = { class: "new_ul" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_div" }, " 1.Join us to open pickup station in your city. ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_div" }, " 2.Share with your friends to open pickup stations. ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, {
      title: "Add Address",
      backgroundColor: "#424040",
      fontColor: "#fff",
      skipPath: "/"
    }),
    ($setup.list && $setup.list.length > 0)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.id,
              onClick: ($event: any) => ($setup.setUndone(item))
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", null, [
                  ($setup.route.query.pickup_id == item.id)
                    ? (_openBlock(), _createBlock(_component_van_icon, {
                        key: 0,
                        name: "checked",
                        color: "#f76900"
                      }))
                    : (_openBlock(), _createBlock(_component_van_icon, {
                        key: 1,
                        name: "location-o"
                      }))
                ]),
                _createElementVNode("span", null, _toDisplayString(item.address), 1)
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("p", null, _toDisplayString(item.address_name), 1)
              ])
            ], 8, _hoisted_2))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    ($setup.list && $setup.list.length <= 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("img", {
              src: 'https://image.kilimall.com/kenya/new_wap/address/null.png'.webpFilters()
,
              alt: ""
            }, null, 8, _hoisted_7),
            _hoisted_8
          ]),
          _hoisted_9,
          _createElementVNode("ul", _hoisted_10, [
            _createElementVNode("li", null, [
              _hoisted_11,
              _createElementVNode("div", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.actv_application_fn && $setup.actv_application_fn(...args))),
                class: "btn_div"
              }, "Join us")
            ]),
            _createElementVNode("li", null, [
              _hoisted_12,
              _createElementVNode("div", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.share_show_fn && _ctx.share_show_fn(...args))),
                class: "btn_div"
              }, "Share")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}